export default "__VITE_ASSET__gdSgUuwR__"